// Восстановление пароля и подтверждение почты.
//
// Запросы намеренно не workspace-scoped: человек в этот момент может быть вовсе
// не в системе.
import { apiPost } from '../../../shared/api-client/index.js';

export async function requestPasswordReset(email: string): Promise<void> {
  await apiPost<{ ok: boolean }, { email: string }>('/auth/forgot-password', { email });
}

export async function resetPassword(token: string, password: string): Promise<void> {
  await apiPost<{ ok: boolean }, { token: string; password: string }>('/auth/reset-password', {
    token,
    password,
  });
}

export async function sendVerificationEmail(): Promise<void> {
  await apiPost<{ ok: boolean }, Record<string, never>>('/auth/send-verification', {});
}

export async function verifyEmail(token: string): Promise<{ email: string }> {
  return apiPost<{ email: string }, { token: string }>('/auth/verify-email', { token });
}
